import React from 'react';
import Spinner from 'react-mdl/lib/Spinner';

export default () => (
    <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translateX(-50%) translateY(-50%)'}}>
        <Spinner singleColor/>
    </div>
);


/** WEBPACK FOOTER **
 ** ./src/loader.js
 **/